// createAccountStyles.js
import styled from 'styled-components';

/* Page + layout */
export const Page = styled.div`
  min-height: 100vh;
  background: #f9fafb; /* gray-50 */
`;

export const Container = styled.div`
  max-width: 42rem; /* ~max-w-2xl */
  margin: 0 auto;
  padding: 1rem 0;

  @media (min-width: 640px) {
    padding: 1.5rem; /* sm:p-6 */
  }
`;

/* Buttons */
export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;

  margin-bottom: 1rem;

  @media (min-width: 640px) {
    margin-bottom: 1.5rem;
  }

  color: #1f2937; /* text-gray-800 */
  font-weight: 600;
  padding: 0.5rem 1.5rem;
  border-radius: 9999px;
  background: #d2fa52;
  border: none;
  cursor: pointer;

  &:hover {
    filter: brightness(0.98);
  }

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

/* Cards */
export const DCard = styled.div`
  border: 0;
  border-radius: 1rem;
  background: #ffffff;
  margin-bottom: 1.5rem;

  @media (min-width: 640px) {
    margin-bottom: 2rem;
  }
`;

export const DCardBody = styled.div``;

export const AlertCard = styled.div`
  background: #fef2f2; /* red-50 */
  border: 2px solid #fca5a5; /* red-300 */
  border-radius: 1rem;
  margin-bottom: 1.5rem;

  @media (min-width: 640px) {
    margin-bottom: 2rem;
  }
`;

export const AlertBody = styled.div`
  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

/* Headings */
export const HeadingGroup = styled.div`
  text-align: center;
  margin: 3rem 0;
`;

export const Title = styled.h1`
  color: #005d1f;
  font-weight: 600;
  font-size: 24px;
  margin-bottom: 8px;
`;

export const Subtitle = styled.p`
  color: #000000;
  font-size: 16px;

  b {
    font-weight: 600;
    display: inline-block;
  }
`;

/* Form */
export const Field = styled.div`
  display: block;
`;

export const ALabel = styled.label`
  display: inline-block;
  color: #374151; /* gray-700 */
  font-weight: 500;
`;

export const TextInputWrap = styled.div`
  position: relative;
`;

export const RightIconButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  display: inline-flex;
  color: #6b7280; /* gray-500 */
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    color: #374151; /* gray-700 */
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;

/* Password requirements */
export const ReqList = styled.div`
  margin-top: 0.75rem;
`;

export const ReqTitle = styled.p`
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 16px;
`;

export const ReqRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
  }

  & + & {
    margin-top: 16px;
  }
`;

/* Demo box */
export const DemoCard = styled.div`
  background: #f3f4f6; /* gray-100 */
  border: 2px dashed #d1d5db; /* gray-300 */
  border-radius: 1rem;
`;

export const DemoBody = styled.div`
  padding: 1.5rem;
`;

export const Center = styled.div`
  text-align: center;
`;

export const HelperText = styled.p`
  font-size: 14px;
  color: #4f4c4d;
  margin-top: 8px;
`;

export const AlertTitle = styled.h3`
  font-weight: 700;
  color: #7f1d1d; /* red-800 */
  margin-bottom: 0.25rem;
  margin-top: 0;
`;

export const AlertText = styled.p`
  color: #b91c1c; /* red-700 */
`;

export const AlertDismiss = styled.button`
  margin-top: 0.75rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #fca5a5; /* red-300 */
  color: #b91c1c; /* red-700 */
  background: #fff;
  border-radius: 0.375rem;
  cursor: pointer;

  &:hover {
    background: #fef2f2;
  }
`;
